module.exports = __webpack_public_path__ + "static/logo-feb343ba7d97a6460a850fd4eaeb529d.png";